// extracted by mini-css-extract-plugin
export default {"root":"mZ6Oc","variant-horizontal":"XHNP6","variantHorizontal":"XHNP6","title":"_2IH8q","message":"_38pAM","core-star":"_1YAwi","coreStar":"_1YAwi"};